/**
 * @description monitor 主要用于业务、性能、代码的监控计算，等同于一个插拔脚本
 */

export { feBot } from './fe_bot';

import { ImageUploadMonitor } from './image_upload_context';

/**
 * @description 批量图像业务 - 图像上传监控
 */
export const batch_imageUpload_monitor = new ImageUploadMonitor();
